import React from 'react';

import { useEvent } from '@legacy-providers/event';

import { getCrewMemberOptionsForRegistration } from '@shared/crew-members/endpoints/getCrewMemberOptionsForRegistration';
import { Form, useForm } from '@shared/forms/components/Form';
import { SelectField } from '@shared/forms/components/SelectField';
import { TextField } from '@shared/forms/components/TextField';
import {
  HandOutParkingRequestParkingSticker,
  handOutParkingSticker,
} from '@shared/parking-stickers/endpoints/handOutParkingSticker';

type ParkingRequestParkingSticker = App.Domain.Parking.Data.ParkingRequestParkingStickerData;

type RejectParkingRequestParkingStickerButtonFormProps = {
  parkingRequestParkingSticker: ParkingRequestParkingSticker;
  onSave: (data: ParkingRequestParkingSticker) => void;
  onCancel: () => void;
};

export function HandOutParkingStickerButtonForm({
  parkingRequestParkingSticker,
  onSave,
  onCancel,
}: RejectParkingRequestParkingStickerButtonFormProps) {
  const { form, fields } = useForm<HandOutParkingRequestParkingSticker>({
    defaults: {
      claimingCrewMemberId: parkingRequestParkingSticker.parkingRequest!.crewMemberId,
    },
  });
  const event = useEvent();

  return (
    <Form
      form={form}
      confirmation={{
        title: 'Success',
        description: 'Parking sticker handed out.',
      }}
      action={(data) => handOutParkingSticker(event.id, parkingRequestParkingSticker.id, data)}
      onSave={onSave}
      onCancel={onCancel}
    >
      <p>
        You're about to hand out a <strong>{parkingRequestParkingSticker.parkingSticker!.name}</strong> sticker.
      </p>

      <SelectField
        name={fields.claimingCrewMemberId}
        label="Crew Member"
        options={(query) =>
          getCrewMemberOptionsForRegistration(parkingRequestParkingSticker.parkingRequest!.registrationId, query)
        }
        required
      />

      <TextField name={fields.code} type="number" label="Sticker Code" />
    </Form>
  );
}
